import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CmpsDialog, CmpsDialogRef } from '@cmps/ng-uikit';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { DataSource } from '../../../backend';
import { Step } from '../../../builder-selection';
import { currentBuilderState, defaultBuilderState } from '../../builder.state';
import { changeStep, nextStep } from '../../function/change-step.function';
import { createRun } from '../../function/create-run.function';
import { loadRouterQueryParams } from '../../function/load-router-query-params.function';
import { reset } from '../../function/reset.function';
import { updateRouterQueryParams } from '../../function/update-router-query-params.function';
import { BuilderState } from '../../model/builder-state.model';
import { SelectionService } from '../../service/selection.service';
import { PresetsDialogComponent } from '../presets-dialog/presets-dialog.component';
import { SavePresetDialogComponent } from '../save-preset-dialog/save-preset-dialog.component';
import { ScheduleDialogComponent } from '../schedule-dialog/schedule-dialog.component';

@Component({
    selector: 'cmps-report-builder-builder',
    templateUrl: './builder.component.html',
})
@TakeUntilDestroy()
export class BuilderComponent implements OnInit, OnDestroy {
    /** @private */
    readonly _Step = Step;

    /** @private */
    readonly _DataSource = DataSource;

    /** @private */
    readonly _changeStep = changeStep;

    /** @private */
    _state: BuilderState;

    /** @private */
    _presetsRef: CmpsDialogRef<PresetsDialogComponent, void>;

    /** @private */
    _savePresetRef: CmpsDialogRef<SavePresetDialogComponent, void>;

    /** @private */
    _scheduleRef: CmpsDialogRef<ScheduleDialogComponent, void>;

    constructor(
        private readonly _router: Router,
        private readonly _dialog: CmpsDialog,
        private readonly _selectionService: SelectionService,
    ) {
        defaultBuilderState();
        this._state = currentBuilderState();
    }

    ngOnInit(): void {
        reset();
        loadRouterQueryParams();
        updateRouterQueryParams();
        this._selectionService.onLoad();
    }

    ngOnDestroy(): void {
        this._presetsRef?.close();
        this._savePresetRef?.close();
        this._scheduleRef?.close();
    }

    /** @private */
    _onResetClick(): void {
        reset();
        updateRouterQueryParams();
    }

    /** @private */
    _onPresetsClick(): void {
        this._presetsRef = this._dialog.open(PresetsDialogComponent, {});
    }

    /** @private */
    _onNextClick(): void {
        nextStep();
    }

    /** @private */
    _onSavePresetClick(): void {
        this._savePresetRef = this._dialog.open(SavePresetDialogComponent, {});
    }

    /** @private */
    _onScheduleClick(): void {
        this._scheduleRef = this._dialog.open(ScheduleDialogComponent, {});
    }

    /** @private */
    _onGenerateClick(): void {
        this._state.creatingRun = true;

        createRun()
            .pipe(
                tap((ret) => {
                    this._state.creatingRun = false;

                    if (ret?.runId == null) {
                        return;
                    }

                    void this._router.navigate([
                        '/',
                        'report',
                        'runs',
                        ret.runId,
                    ]);
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
